<template>
  <h1>{{title}}</h1>
</template>

<script>

export default {
  name: "CheckListTitle",
  data: () => ({
  }),
  methods: {
  },
  components: {
  },
  props: ['title']
};

</script>

<style scoped>
h1 {
  color: #fff;
  text-align: left;
}
</style>
